import { Observable } from 'tsbase/Patterns/Observable/Observable';
import { BreakingErrors, DismissibleErrors } from '../core/enums/module';

export const Error = new Observable<
  DismissibleErrors |
  BreakingErrors |
  { error: DismissibleErrors | BreakingErrors, additionalDetails: string }
>();
